import React, { FunctionComponent, useContext } from "react";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl-phraseapp";
import { useFlags } from "launchdarkly-react-client-sdk";
import { Alert } from "@cmsgov/ds-medicare-gov";
import routes from "../../app/routes";
import { useTranslate } from "../../helpers";
import { AppStore } from "../../app/store";
import { HelpDrawerWrapper } from "../../components";
import OutsideOpenEnrollmentHelp from "./OutsideOpenEnrollmentHelp";
import { AnalyticsActionType } from "../../app/contexts/Analytics/types";

const OEYearAlert: FunctionComponent = () => {
  const t = useTranslate();
  const {
    state: { beneficiary, year },
    dispatch,
  } = useContext(AppStore.AppContext);
  const { mctCurrentPlanYear } = useFlags();
  const forNextYear = year === (mctCurrentPlanYear + 1).toString();
  const otherYear = forNextYear ? mctCurrentPlanYear : mctCurrentPlanYear + 1;

  const link = (
    <Link
      to={`${
        beneficiary ? routes.summary.landingPage : routes.questionRouting
      }?year=${otherYear}`}
      onClick={(): void => {
        dispatch({
          type: AnalyticsActionType.SEND_TEALIUM_EVENT,
          settings: {
            event_action: "Find Plans - Enter Your Information",
            event_label: `Look at ${otherYear} Plans`,
          },
        });
      }}
    >
      <FormattedMessage
        id={
          forNextYear
            ? "explain_plan_year.next_year_link"
            : "explain_plan_year.current_year_link"
        }
        values={{ year: otherYear }}
      />
    </Link>
  );

  const alertMessage = forNextYear ? (
    <FormattedMessage
      id="explain_plan_year.next_year"
      values={{
        year,
        link,
      }}
    />
  ) : (
    <>
      <p className="ds-u-margin-top--0">
        <FormattedMessage
          id="explain_plan_year.current_year"
          values={{
            year,
            otherYear,
            link,
          }}
        />
      </p>
      <p className="ds-u-margin-bottom--0 e2e-sep-alert">
        <FormattedMessage id="explain_plan_year.current_year_switch_certain_times" />
        {` `}
        <HelpDrawerWrapper
          inlineToggle
          toggleText={t("what_coverage.outside_open_enrollment_drawer_link")}
          drawerTitle={t("ooe_help.heading")}
        >
          <OutsideOpenEnrollmentHelp />
        </HelpDrawerWrapper>
      </p>
    </>
  );

  return (
    <div className="e2e-oe-year-alert">
      <Alert hideIcon={true} variation={forNextYear ? undefined : "warn"}>
        {alertMessage}
      </Alert>
    </div>
  );
};

export default OEYearAlert;
